if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.copyButton = this.querySelector('.share-button__copy');
      this.closeButton = this.querySelector('.share-button__close');
      this.successMessage = this.querySelector('[id^="ShareMessage"]');

      // Use current page URL
      this.urlToShare = window.location.href;

      // Attach copy button listener
      if (this.copyButton) {
        this.copyButton.addEventListener('click', (event) => {
          event.stopPropagation(); // prevent details toggle issues
          console.log('copy button clicked');
          this.copyToClipboard();
        });
      }

      // Attach close button listener
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.closeDetails());
      }

      // Click outside closes the dropdown
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target) && this.details && this.details.open) {
          this.closeDetails();
        }
      });
    }

    copyToClipboard() {
      const url = this.urlToShare;

      navigator.clipboard.writeText(url).then(() => {
        if (this.successMessage) {
          this.successMessage.classList.remove('hidden');
        }
        this.closeDetails();
      }).catch(() => {
        alert('Unable to copy the URL. Please copy manually.');
      });
    }

    closeDetails() {
      if (this.details) this.details.open = false;
      if (this.closeButton) this.closeButton.classList.add('hidden');
    }

    updateUrl(url) {
      this.urlToShare = url;
    }
  });
}